import { createApiSlice } from "@common";
import {
  CRUD_PROSPECT_TAGGING,
  CRUD_PROSPECT_TAGGING_ID
} from "@routes";
// Define the API config array
const apiConfig = [
  {
    name: "addProspectTagging",
    method: "post",
    url: CRUD_PROSPECT_TAGGING,
    stateKey: "message",
  },
  {
    name: "getProspectTaggingById",
    method: "get",
    url: CRUD_PROSPECT_TAGGING_ID,
    stateKey: "data",
  },
  {
    name: "updateProspectTagging",
    method: "put",
    url: CRUD_PROSPECT_TAGGING,
    stateKey: "message",
  },
  {
    name: "deleteProspectTagging",
    method: "delete",
    url: CRUD_PROSPECT_TAGGING,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "prospectTagging",
  apiConfig,
  customReducers,
);
const prospectTaggingSlice = slice;

// Export the slice's reducer
export default prospectTaggingSlice.reducer;

// Export thunks
export const {
  addProspectTagging,
  getProspectTaggingById,
  updateProspectTagging,
  deleteProspectTagging,
} = thunks;

// Export actions
export const { rowSelect } = actions;
